/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

export  const normalizeWorkingHours = (rows: any) => {
  const map: { [key: string]: Array<{ start: string; end: string; isClosed: boolean }> } = {};
interface WorkingHourRow {
    day: string;
    openingTime: string;
    closingTime: string;
    isClosed: boolean;
}

interface WorkingHour {
    start: string;
    end: string;
    isClosed: boolean;
}

rows.forEach((r: WorkingHourRow) => {
    // match JS weekday string with DB day
    const dayKey = getDayKey(r.day); 
    if (!map[dayKey]) map[dayKey] = [];

    map[dayKey].push({
        start: r.openingTime.slice(0,5), // "09:00"
        end: r.closingTime.slice(0,5),   // "18:00"
        isClosed: r.isClosed
    } as WorkingHour);
});
  return map;
};

// helper to convert DB "Sun" -> "sunday"
const getDayKey = (dbDay: string): string => {
  const dict: { [key in 'sun' | 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat']: string } = {
    sun: "sunday",
    mon: "monday",
    tue: "tuesday",
    wed: "wednesday",
    thu: "thursday",
    fri: "friday",
    sat: "saturday",
  };
  const key = dbDay.toLowerCase().slice(0,3) as keyof typeof dict;
  return dict[key];
};